var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 1H5C4.60218 1 4.22064 1.15804 3.93934 1.43934C3.65804 1.72064 3.5 2.10218 3.5 2.5V13.5C3.5 13.8978 3.65804 14.2794 3.93934 14.5607C4.22064 14.842 4.60218 15 5 15H11C11.3978 15 11.7794 14.842 12.0607 14.5607C12.342 14.2794 12.5 13.8978 12.5 13.5V2.5C12.5 2.10218 12.342 1.72064 12.0607 1.43934C11.7794 1.15804 11.3978 1 11 1ZM11.5 13.5C11.5 13.6326 11.4473 13.7598 11.3536 13.8536C11.2598 13.9473 11.1326 14 11 14H5C4.86739 14 4.74021 13.9473 4.64645 13.8536C4.55268 13.7598 4.5 13.6326 4.5 13.5V2.5C4.5 2.36739 4.55268 2.24021 4.64645 2.14645C4.74021 2.05268 4.86739 2 5 2H11C11.1326 2 11.2598 2.05268 11.3536 2.14645C11.4473 2.24021 11.5 2.36739 11.5 2.5V13.5ZM8.75 3.75C8.75 3.89834 8.70601 4.04334 8.6236 4.16668C8.54119 4.29001 8.42406 4.38614 8.28701 4.44291C8.14997 4.49968 7.99917 4.51453 7.85368 4.48559C7.7082 4.45665 7.57456 4.38522 7.46967 4.28033C7.36478 4.17544 7.29335 4.0418 7.26441 3.89632C7.23547 3.75083 7.25032 3.60003 7.30709 3.46299C7.36386 3.32594 7.45999 3.20881 7.58332 3.1264C7.70666 3.04399 7.85166 3 8 3C8.19891 3 8.38968 3.07902 8.53033 3.21967C8.67098 3.36032 8.75 3.55109 8.75 3.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/Mobile.7b8dc8a8ecb1ebafc4ecba4795d0bd15.svg";
export { ForwardRef as ReactComponent };